import ContactRepository from '@/js/repositories/ContactRepository'
import store from '../../store'
import i18n from '@/lang/i18n';

const state = {
  contact: {},
  errorMsg: '',
}

const getters = {
  contactAutoFill: (state) => {
    let contact = state.contact
    let doctorInfo = store.state.auth.doctorInfo
    contact.email = contact.confirmEmail = doctorInfo.email
    contact.facilityName = store.state.auth.typeOfUser === 'pharmacy' ? doctorInfo.pharmacy_name : doctorInfo.hospital_name
    contact.name = doctorInfo.name
    return contact
  }
}

const actions = {
  init ({ commit }) {
    commit('INIT')
  },
  setContact ({ commit }, data) {
    commit('CONTACT', data)
  },
  setContactContent ({ commit }, data) {
    commit('CONTENT', data)
  },
  async sendContact ({ commit }, data) {
    await ContactRepository.sendContact(data)
      .then(resp => {
        commit('SEND_EMAIL_ERROR', '')
      })
      .catch(error => {
        let errMsg = error.request ? i18n.t('not_connected_to_the_network') : i18n.t('api_has_occurred_with_status', {status: error.response.status})
        commit('SEND_EMAIL_ERROR', errMsg)
      })
  }
}

const mutations = {
  INIT (state) {
    state.contact = {}
    state.errorMsg = ''
  },
  CONTACT (state, data) {
    state.contact = data
  },
  CONTENT (state, data) {
    state.contact.content = data
  },
  SEND_EMAIL_ERROR (state, errMsg) {
    state.errorMsg = errMsg
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
